'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.millisecondsBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/millisecondsBefore.js
// module id = 351
// module chunks = 1